<template>
  <div class="multiple-app-form-container">
    <div class="multiple-app-form-content">
      <div v-for="(form_item, field_key) in formFields" :key="field_key">
        <div v-if="form_item.title" class="card-header w-full flex items-center">
          <h3 slot="header" class="title m-0">{{ form_item.title }}</h3>
        </div>
        <app-form
          :ref="field_key"
          :default-label-width="defaultLabelWidth"
          :submit-request="(params) => onSubmit(params, field_key)"
          :form-data="form_item.config"
          :is-show-button="false"
          :form-props="{ labelPosition: 'right' }"
        >
          <template #custom="custom">
            <slot name="custom" v-bind="custom" />
          </template>
        </app-form>
      </div>
    </div>
    <div class="multiple-app-form-footer">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    'app-form': () => import('@/components/app-form'),
  },
  props: {
    // 表单配置
    formFields: {
      type: Object,
      default() {
        return {};
      },
    },
    // 表单label宽度
    defaultLabelWidth: {
      type: String,
      default: '170px',
    },
  },
  data() {
    return {
      form_model: {},
    };
  },
  methods: {
    /**
     * 效验所有表单
     * @param is_validate 是否效验数据
     * @param is_filter_empty 是否过滤空值
     * @returns {Promise<boolean>}
     */
    async validateAllForm(is_validate = true, is_filter_empty = true) {
      let valid = false;
      this.form_model = {};
      for (const field in this.$refs) {
        if (Object.hasOwnProperty.call(this.$refs, field)) {
          const refs = this.$refs[field];
          for (const ref of refs) {
            valid = await ref.confirm(is_validate, is_filter_empty);
            if (!valid && is_validate) {
              break;
            }
          }
          if (!valid && is_validate) {
            break;
          }
        }
      }
      return valid;
    },
    /**
     * 表单回调
     * @param {Object} params 表单数据
     * @param {string} field ref键名
     */
    onSubmit(params, field) {
      Object.assign(this.form_model, { [field]: params });
    },
    async confirm() {
      const is_valid = await this.validateAllForm();
      if (is_valid) {
        this.$emit('confirm', this.form_model);
      }
    },
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss">
.multiple-app-form-container {
  position: relative;
  width: 100%;
  height: 100%;
  padding-bottom: 56px;
  .multiple-app-form-content {
    height: 100%;
    overflow: auto;
    .card-header {
      padding: 0 20px;
      min-height: 42px;
      border-bottom: 1px solid rgb(240, 240, 240);
      background: rgba(0, 0, 0, 0.02);
      transition: background 0.2s ease;
    }
  }
  .multiple-app-form-footer {
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 20px;
    width: 100%;
  }
}
</style>
